module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/042-aruba-1f73df73537f6e31973b67083424d229.svg";